// تعريف الأدوار
export const ROLES = {
  FREE: 'free',
  PRO: 'pro',
  ADMIN: 'admin',
  SUPER: 'super_user'
};

// تعريف صلاحيات الألعاب (شنو اللي فابور وشنو اللي بالخلاص)
export const GAME_PERMISSIONS = {
  maze: ROLES.FREE,        // المتاهة: فابور
  wordsearch: ROLES.FREE,  // البحث عن الكلمات: فابور
  math: ROLES.FREE,        // الرياضيات: فابور
  wordscramble: ROLES.FREE,
  pyramid: ROLES.FREE,
  
  // ألعاب البرو
  sudoku: ROLES.PRO,       
  crossword: ROLES.PRO,    
  jigsaw: ROLES.PRO,       
  bingo: ROLES.PRO,        
  snakes: ROLES.PRO,
};

// إعدادات كل دور (الحدود والمميزات)
export const ROLE_CONFIG = {
  [ROLES.FREE]: {
    maxPages: 5,           // حد الصفحات للمجاني
    canDownloadPDF: false, // واش يقدر يحمل PDF
    watermark: true        // واش كاين علامة مائية
  },
  [ROLES.PRO]: {
    maxPages: 100,
    canDownloadPDF: true,
    watermark: false
  },
  [ROLES.ADMIN]: {
    maxPages: 9999,
    canDownloadPDF: true,
    watermark: false
  },
  [ROLES.SUPER]: {
    maxPages: 9999,
    canDownloadPDF: true,
    watermark: false
  }
};

// 1. دالة التحقق من الوصول (للدخول للصفحات)
export const canAccess = (userRole, requiredRole) => {
  if (!userRole) return false;
  if (userRole === ROLES.ADMIN || userRole === ROLES.SUPER) return true;
  if (userRole === ROLES.PRO) return true;
  if (requiredRole === ROLES.FREE) return true;
  return false;
};

// 2. دالة جلب الإعدادات (هادي هي اللي كانت ناقصة) ✅
export const getConfig = (role) => {
  // إلا كان الدور غير معروف، عطيه إعدادات Free
  return ROLE_CONFIG[role] || ROLE_CONFIG[ROLES.FREE];
};